import { render, staticRenderFns } from "./SubBottomBar.vue?vue&type=template&id=9bf283ae"
import script from "./SubBottomBar.vue?vue&type=script&lang=js"
export * from "./SubBottomBar.vue?vue&type=script&lang=js"
import style0 from "./SubBottomBar.vue?vue&type=style&index=0&id=9bf283ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports